import { Modal } from '@/components/dialogs/Modal';
import { Spinner } from '@/components/common/Spinner';
import { ErrorState } from '@/components/common/ErrorState';
import type { TerminalRequestRefInput } from '@/api/types/terminalRequests';
import { useTerminalRequestDetails } from './api';

function display(v: string | number | boolean | null | undefined): string {
  if (v === null || v === undefined || v === '') return 'N/A';
  return String(v);
}

interface TerminalRequestDetailsModalProps {
  show: boolean;
  target: TerminalRequestRefInput | null;
  onClose: () => void;
}

// Reproduces the legacy "Requested Values" info dialog (fa-eye row action).
export function TerminalRequestDetailsModal({
  show,
  target,
  onClose,
}: TerminalRequestDetailsModalProps) {
  const query = useTerminalRequestDetails(show ? target : null);
  const d = query.data;

  const rows: Array<[string, string]> = d
    ? [
        ['Client', display(d.tenantName)],
        ['User', display(d.userName)],
        ['Type', display(d.requestType)],
        ['Status', display(d.status)],
        ['Terminal', display(d.terminalName)],
        ['Connection Type', display(d.connectionType)],
        ['Server', display(d.server)],
        ['Account Login', display(d.accountLogin)],
        ['Password', display(d.password)],
        ['Enabled', display(d.enabled)],
      ]
    : [];

  return (
    <Modal
      show={show}
      title="Requested Values"
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Ok
        </button>
      }
    >
      {query.isLoading ? (
        <Spinner />
      ) : query.isError ? (
        <ErrorState message="Failed to load details." onRetry={() => query.refetch()} />
      ) : (
        <div className="text-start">
          {rows.map(([label, value]) => (
            <div className="mb-1" key={label}>
              <strong>{label}:</strong> {value}
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
